import React, { useState } from 'react';
import OtpInputBox from '../../../UI/OtpInputBox';

const BankAccNo = ({
    saveInputAns,
    SkippedLeads,
    setClickedSlide,
    setAccNum,
    clsName,
    reff
}) => {
    const [otp, setOtp] = useState("");
    const [error, setError] = useState(false);

    const handleOtpChange = (otp) => {
        setOtp(otp);
        setAccNum(otp);
        console.log("OTP Value:", otp);
    };
    const skipNext = (otp) => {
        let array = JSON.parse(localStorage.getItem('questionData'));
        array = array.filter(item => item.question_id !== 87);
        localStorage.setItem('questionData', JSON.stringify(array));
        SkippedLeads("skipAccountNumber", false)
        setClickedSlide({ slide: "bank_acc_no" });
    };

    const handleNext = async (e) => {
        if (otp.length != 8) {
            setError(true);
            return;
        } else if (parseInt(otp) === 0) {
            setError(true);
            return;
        } else {
            setError(false)
            saveInputAns(e);
        }
    };


    return (
        <div className={`radio-box animated fadeInUp text-center ${clsName}`} ref={reff} >
            <h3><b>{`Please provide your Bank Account Number`}</b></h3>
            <div className="col-lg-12 mb-2">
                <div className="otp-input">
                    <OtpInputBox
                        length={8}
                        onChange={handleOtpChange}
                        className={'otp-input-field'}
                    />
                </div>
                {error && (
                    <span className='error_msg mt-2'>Please enter a valid Bank Account Number</span>
                )}
            </div>
            <div className="col-xl-12 col-lg-12 text-center p-0" >
                <button
                    type="button"
                    className="btn-next"
                    onClick={handleNext}
                    data-quest-id={87}
                    data-ans-id={null}
                    data-ans-label={null}
                    name="bank_acc_no"
                >{`NEXT`}</button>
                <span className='warning-text'>{"(Please confirm your Account Number to expedite your claim. If you prefer not to, you can skip this step.)"}</span>
                <br />
                <span className='col-12 text-center mt-1'><img src="../../assets/NDY_UB_2/img/secure_icon.png" style={{ width: "81px" }} /></span>
            </div>
            <div className="row">
                <div className="mb-2 mt-3 text-center">
                    <a className="backbtn skip-btn" name="bank_acc_no" onClick={skipNext}>{"Skip"}</a>
                </div>
            </div>
        </div>
    );
};

export default BankAccNo;
